import { Component, inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ButtonComponent } from '@ppl/ui';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzInputModule } from 'ng-zorro-antd/input';
import { BaseComponent } from '../../../../shared/utils/base.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { CommonModule, DatePipe } from '@angular/common';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { RADIO_YES_NO_OPTIONS, STATIC_JSON_DATA_PATH } from '../../../../shared/constants/static-data.constants';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { SectionsService } from '../../../../services/sections.service';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ActivatedRoute, Router } from '@angular/router';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { AccordionComponent } from '@ppl/ui';
import { AuthUtilizationComponent } from "../auth-utilization/auth-utilization.component";
import { AuthUtilizationLineDetailsComponent } from "../auth-utilization-line-details/auth-utilization-line-details.component";
import {  ListTableComponent  } from '@ppl/ui';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { GridAction } from '@ppl/ui';
import { AuthFormsComponent } from "../auth-forms/auth-forms.component";
import { AuthorizationsDetailsService } from '../../../../services/authorizations-service.service';
import { ListService } from '../../../../shared/services/list.service';
import { AuthorizationDocumentsComponent } from '../authorization-documents/authorization-documents.component';
import { ClaimsService } from '../../../../services/claims.service';
import { AuthAdditionalDetailsComponent } from '../auth-additional-details/auth-additional-details.component';
import { NotificationService } from '../../../../shared/services/notification.service';
import { DialogConfig, DialogService } from '../../../../shared/services/dialog.service';
import { UserService } from '../../../../services/user.service';
import { AuthAllocationListComponent } from "../auth-allocation-list/auth-allocation-list.component";
import { TableModule } from 'primeng/table';
import { AuditHistoryComponent } from '../../../../shared/modals/audit-history/audit-history.component';
import { AllowListAuthStore } from '../../../../shared/authorization/allow-list-auth.store';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
@Component({
  selector: 'ppl-authorization-details',
  standalone: true,
  imports: [ButtonComponent,
    NzFormModule,
    ReactiveFormsModule,
    FormsModule,
    NzCardModule,
    NzInputModule,
    NzToolTipModule,
    CommonModule,
    NzDatePickerModule,
    NzToolTipModule,
    NzSelectModule,
    NzButtonModule,
    NzCollapseModule,
    AccordionComponent,
    AuthUtilizationComponent,
    AuthUtilizationLineDetailsComponent,
    ListTableComponent,
    AuthFormsComponent,
    AuthorizationDocumentsComponent,
    AuthAdditionalDetailsComponent, AuthAllocationListComponent, AuditHistoryComponent,
    TableModule],
  templateUrl: './authorization-details.component.html',
  styleUrl: './authorization-details.component.css'
})
export class AuthorizationDetailsComponent extends BaseComponent implements OnInit {
  authorizationsForm!: FormGroup;
  radioOptions = RADIO_YES_NO_OPTIONS;
  providerTypes: any;
  pageTitle = 'Add Authorization';
  mode = 'read';
  savedData: any = {};
  isNew = true;
  isParticipantSelected = false;
  isConsumerSelected = false;
  showConsumersList = false;
  programName!: string;
  columnsToBeHidden: any;
  sharedDataKey: any;
  actionsToBeHidden: any;
  lazyLoad = true;
  cols: any[] = [];
  flow: string | null = '';
  selectedConsumer: any;
  selectedAuthId: any;
  diagnosisCodesList: any;
  filledDiagnosisValue = '';
  disableForm = true;
  actionButtons: TableRowActionsModel = new TableRowActions({ add: true });
  authData: any;
  showDeleteBtn = true;
  private dialogSvc = inject(DialogService);
  // True only on the routed authorization details page; when embedded (e.g. in a dialog) the route is the host page's.
  private readonly isRoutedPage = inject(ActivatedRoute).component === AuthorizationDetailsComponent;
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;
  @ViewChild('authDialog') authDialog!: TemplateRef<any>;
  @ViewChild('authHistoryDialog') authHistoryDialog!: TemplateRef<any>;
  @Input() pageSource: any;
  /**
   * Authorization to show. Always pass it when rendering this component inside another page (e.g. a
   * dialog): the host page's shared selected lead / flow must not be overwritten with the auth id, or
   * any page reached afterwards (browser back, tabs) would load data for the wrong record.
   * Only the routed authorization details page leaves it unset and falls back to the shared context.
   */
  @Input() authorizationId: any;
  auditHistoryColumns: any[] = [];
  authHistoryFormattedData: any[] = [];
  auth_cols: any = [
    {
      "field": "authDetailId",
      "header": "Authorization ID",
      "jsonpath": "authDetailId",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "startDate",
      "header": "Start Date",
      "jsonpath": "startDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "endDate",
      "header": "End Date",
      "jsonpath": "endDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "units",
      "header": "Units",
      "jsonpath": "units",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "usedUnits",
      "header": "Used Dollars",
      "jsonpath": "usedUnits",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    }
  ]
  regionalCenters: any[] = [];
  serviceCodes: any[] = [];

  @Input() isReadOnly = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private sectionsService: SectionsService,
    private listService: ListService,
    private authorizationService: AuthorizationsDetailsService,
    private notificationService: NotificationService,
    private claimsService: ClaimsService,
    private userService: UserService,
    private datePipe: DatePipe,
    private allowListStore: AllowListAuthStore,
  ) {
    super();
  }

  ngOnInit(): void {
    this.authorizationsForm = this.fb.group({
      firstName: [[]],
      lastName: [[]],
      medicaid: [[]],
      pplId: [[]],
      plAuthNumber: [[]],
      clientAuthNumber: [[]],
      hcpcsServiceCode: [[]],
      modifier1: [null],
      modifier2: [null],
      modifier3: [null],
      modifier4: [null],
      units: [[]],
      dollars: [[]],
      authStartDate: [[]],
      authEndDate: [[]],
      mcoId: [[]],
    });

    const program = this.userService.getSelectedProgram();
    // A passed-in auth id always wins. Only the routed page, with no input, may take the auth from the shared
    // context; when embedded, reading the shared selected lead would pick up the host page's member id.
    const hasAuthInput = this.authorizationId != null && this.authorizationId !== '';
    const useSharedContext = !hasAuthInput && this.isRoutedPage;
    this.flow = useSharedContext ? (this.sectionsService.getFlow() ?? '') : 'authorizations';
    this.selectedAuthId = hasAuthInput ? this.authorizationId : (useSharedContext ? this.userService.getSelectedLead() : null);
    this.programName = program?.program_code ?? '';
    this.secData = this.sectionsService.getSectionData(
      program?.program_code,
      'payroll',
      undefined,
      this.flow
    );
    const userDetails = this.userService.getUserDetails();
    const isInRole = program?.roles.some((role: any) => role.role_name === 'PPL Staff Tier 1') && userDetails?.usertype_lkp === 'FMS';
    if (isInRole) {
      this.isReadOnly = true;
    }

    // Generic auth check: if the page has no allowed actions and no allowed buttons, treat as read-only
    const pageId = PAGE_CONSTANTS.AUTHORIZATION_DATA_GRID_PAGE;
    const allowedActions = this.allowListStore.getAllowedActions(pageId);
    const allowedButtons = this.allowListStore.getAllowedButtons(pageId);
    if (allowedActions.length === 0 && allowedButtons.length === 0) {
      this.isReadOnly = true;
    }

    this.providerTypes = this.getLookup('ProviderType');

    this.claimsService.authUpdated.subscribe((val) => {
      if (val) {
        this.getAuthDetails();
      }
    })
    this.getGridHeaders();
    this.getAuthDetails();
    this.getServiceData();
  }

  getServiceData() {
    this.claimsService.getServiceData(this.programName).subscribe((data: any) => {
      this.serviceCodes = data?.responsedata?.serviceCodes;
      this.regionalCenters = data?.responsedata?.organizations;
    })
  }

  returnClicked() {
    console.log('going back from process codes');
    this.router.navigate(['/home/authorizationsList']);
  }

  goBack() {
    this.router.navigate(['/home/authorizationsList']);
  }

  onEdit() {
    this.mode = 'edit';
    this.disableForm = false;
    //patch form here;
  }

  splitAuthData: any;
  authHistoryData: any;

  onViewSplit() {
    this.claimsService.getAuthSpiltData(this.programName, this.authData.authorizationId).subscribe((data: any) => {
      if (data.status == 200) {
        this.splitAuthData = data.responsedata;
        const dialogConfig: DialogConfig = {
          title: 'Split Authorization Data',
          okText: 'Ok',
          size: 'large',
          position: 'top',
          showClose: true,
          showButtons: false,
          styleClass: 'split-auth-data'
        };

        this.dialogSvc.openDialog(
          this.authDialog,
          dialogConfig,
          () => this.handleCancel(),
          () => this.handleCancel()
        );
      }
    })
  }

  onViewAuthHistory() {
    const dialogConfig: DialogConfig = {
          title: 'Auth History Data',
          okText: 'Ok',
          size: 'xx-large',
          position: 'top',
          showClose: true,
          showButtons: false,
          styleClass: 'split-auth-data'
        };
        this.dialogSvc.openDialog(
          this.authHistoryDialog,
          dialogConfig,
          () => this.handleCancel(),
          () => this.handleCancel()
        );
  }

  onConsumerSearch() {
    this.showConsumersList = true;
  }

  async getGridHeaders() {
    try {
      if (this.flow) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(STATIC_JSON_DATA_PATH.AUTHORIZATIONS_CONSUMER_LIST_HEADERS, this.flow);
        console.log(tempCols.columns);
        this.cols = tempCols.columns;
      }
    } catch (e) {
    }

  }

  getAuthDetails() {
    // this.authorizationService.getAuthorizationDetails(this.programName, this.selectedAuthId).subscribe((data: any) => {
    //   console.log('details', data);
    // })

    const payload = this.buildRequestPayload();
    const from = '';
    this.listService.getListData(payload, from).subscribe((data: any) => {
      console.log('search data', data);
      this.authData = data.responsedata[0];
      // this.filledDiagnosisValue = this.diagnosisCodesList?.find((diagnosis:any) => diagnosis?.diagnosisDetailId === this.authData?.diagnosisId)?.description;

      //this.gridData = data.responsedata;
    });

  }

  buildRequestPayload(event?: any) {
    const formData = this.authorizationsForm.value;
    const payload: any = {
      pageName: 'consumer-auth',
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: '1',
      searchParam: [{
        jsonPath: 'authorizationId',
        value: this.selectedAuthId,
        operator: 'equal'
      }],
      orderByColumn: [],
      orderBy: [],
    }

    return payload;
  }

  action(event: GridAction) {
    if (event && event.action === 'add') {
      console.log(event.data);
      this.selectedConsumer = event.data;
      this.isConsumerSelected = true;
      this.showConsumersList = false;
    }

  }

  onAuthUpdate(event: any) {
    console.log('update event!', event);
    this.mode = 'read';
    this.disableForm = true;
    if (event) {
      this.getAuthDetails();
    }
  }

  /** True when no dollars have been spent against this authorization yet. */
  canDeactivateAuthorization(): boolean {
    const spent = parseFloat(this.authData?.usedUnits ?? '0') || 0;
    return spent === 0;
  }

  onDeleteAuth() {
    // Defensive: the button is hidden when spent > 0, but block here too in case it slips through.
    if (!this.canDeactivateAuthorization()) {
      this.notificationService.alert(
        'warning',
        'Cannot Deactivate',
        'This authorization has spent dollars and cannot be deactivated.'
      );
      return;
    }
    console.log('delete clicked');
    this.openConfirmationPopup();
  }

  openConfirmationPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Confirmation',
      okText: 'Ok',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.confirmationDialog,
      dialogConfig,
      () => this.deleteAuth(),
      () => this.handleCancel()
    );
  }

  handleCancel() { }

  deleteAuth() {
    this.authorizationService.deleteAuthorization(this.programName, this.selectedAuthId).subscribe((data: any) => {
      console.log('deleted');
      this.showDeleteBtn = false;
      this.getAuthDetails();
      this.notificationService.alert(
        'success',
        'Success',
        `Authorization deactivated successfully`
      );
    });
  }

  onAdd() {
    console.log('Adding!!');
  }

  onCancel() {
    this.mode = 'read';
    this.disableForm = true;
    this.validationErrors = {};
    this.authorizationsForm.reset();
  }

  onUpdate() {
    console.log('Updating!!');
    this.mode = 'read';
    this.disableForm = true;
    this.validationErrors = {};
    this.authorizationsForm.reset();
  }

  viewerValueChange(value: string) {
    const viewerValue = [value][0];
    this.isParticipantSelected = true;
  }
}
